import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Label = ({ children, ...props }) => {
  const {
    // Colors.
    primary,
    success,
    warning,
    error,
    // Styles.
    rounded,
    // Modifiers.
    small,
    violet,
    // Remaining props to transfer.
    ...otherProps
  } = props;
  const classNames = classnames('label', {
    'label-primary': primary,
    'label-success': success,
    'label-warning': warning,
    'label-error': error,
    'label-rounded': rounded,
    'label-violet': violet,
  });

  const Element = small ? 'small' : 'span';

  return (
    <Element {...otherProps} className={classNames}>
      {children}
    </Element>
  );
};

Label.propTypes = {
  children: PropTypes.node.isRequired,
  primary: PropTypes.bool,
  success: PropTypes.bool,
  warning: PropTypes.bool,
  error: PropTypes.bool,
  violet: PropTypes.bool,
  rounded: PropTypes.bool,
  small: PropTypes.bool,
  tiny: PropTypes.bool,
};

Label.defaultProps = {
  primary: false,
  success: false,
  warning: false,
  error: false,
  violet: false,
  rounded: false,
  small: false,
  tiny: false,
};

export { Label };
